import React from 'react';
import { Link } from "react-router-dom";
import './index.css';
import Resultados from './resultados';
import Segmentos from './segmentos';
import Calendario from './calendario';
import RicoData from './ricodata';
import Movimiento from './movimiento';

export default function Home() {

  return (
    <div className="wrapper">
      <div id='home'>
        <div className="intro">
          <h1>Programa Incluir</h1>
          <p>El programa de inclusión y educación financiera de Banco Provincia, Grupo Provincia, Provincia Servicios Financieros, Provincia Microcréditos y Fundación Banco Provincia.</p>
          <Link to='/que-es-incluir' className='btn-verde'>Conocé más</Link>
        </div>
        <Segmentos />
        <div className="boxes">
          <RicoData />
          <Movimiento />
        </div>
        <Resultados />
        <Calendario />
        <div className="glosario">
          <h4>Glosario</h4>
          <Link to='/glosario' className='btn-verde'>Conocé más</Link>
        </div>
      </div>
    </div>
  );
}